// Copyright (c) 2018 Deere & Company

import actions from '../actions-list';

export const updateSelectedExcelLayout = (selectedExcelLayout, listId) =>

    dispatch =>

        dispatch({
            listId,
            selectedExcelLayout,
            type: actions.UPDATE_SELECTED_EXCEL_LAYOUT
        });



// WEBPACK FOOTER //
// ./src/shared/action-creators/selected-excel-layout.js